<template>
  <div class="list_index">
    <el-table stripe border :data="tableData">
      <el-table-column label="设备序列号" prop="serialNumber" align="center"></el-table-column>
      <el-table-column label="联系人" prop="contacts" align="center"></el-table-column>
      <el-table-column label="手机号" prop="phoneNumber" align="center"></el-table-column>
      <el-table-column label="地址" prop="address" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="报修原因" prop="problemDescription" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="check(scope.row)">通过</el-button>
          <el-button type="text" style="color:red" @click="checkNoadopt(scope.row)">不通过</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import RepairService from '@/api/repair'
export default {
  data(){
    return{
      page: 1,
      count: 0,
      size:10,
      tableData:[],
    }
  },
  methods:{
    getDataList(){
      RepairService.getCheckRepair({
        user_id:this.$store.state.user_id,
        page:this.page,
        size:this.size,
        list:'1'
      }).then(res=>{
        this.tableData = res.data.projectSiteList;
        this.count = res.data.count;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    changePage(page) {
      this.page = page;
      this.getDataList();
    },
    check(val){
      RepairService.checkRepair({
        serviceProgress:2,
        workOrderNo:val.workOrderNo
      }).then(res=>{
        this.$message.success('审核成功')
        this.getDataList()
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    checkNoadopt(val){
      this.$prompt('请输入不通过原因', '审核不通过', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type:'warning',
        }).then(({ value }) => {
          RepairService.checkRepair({
            serviceProgress:0,
            reasonsForRefusal:value,
            workOrderNo:val.workOrderNo
          }).then(res=>{
            this.$message.success('提交成功')
            this.getDataList()
          }).catch(err=>{
            this.$message.error(err.message)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    }
  },
  mounted(){
    this.getDataList()
  }
}
</script>

<style>

</style>